import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';

interface ItemType {
    img: string[];
    title: string;
    desc: string;
}
export default function N() {
    const { t } = useLang('bkw');
    const items: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738914762430/14_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738914793078/14_1_M.jpg'],
            title: t('N_item1_title'),
            desc: t('N_item1_desc'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738914763240/14_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738914762246/14_2_M.jpg'],
            title: t('N_item2_title'),
            desc: t('N_item2_desc'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738914763082/14_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738914763452/14_3_M.jpg'],
            title: t('N_item3_title'),
            desc: t('N_item3_desc'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738914762627/14_4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738914762830/14_4_M.jpg'],
            title: t('N_item4_title'),
            desc: t('N_item4_desc'),
        },
    ];

    return (
        <div id="bkw-N" className={`bkw-N bkw-box ${css['bkw-N']}`}>
            <EfSpec />
            <div className="info">
                <h2 className="title">
                    {t.rich('N_title', {
                        y: (tx: string) => <span className="y">{tx}</span>,
                    })}
                </h2>
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li className={`item item-${k + 1}`} key={k} style={{ gridArea: `x${k + 1}` }}>
                        <div className="item-img">
                            <EfImg pc={item.img[0]} pad={item.img[[2, 3].includes(k) ? 0 : 1]} h5={item.img[1]} />
                        </div>
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
